/**
 * Search params for a navigation inside a read-only embed: readonly=true is kept (and the
 * desktop-settable theme), so the desktop app's World Building, Storyboard and Writing
 * Dashboard windows, and a tab on its sign-in fragment, never turn writable or grow the
 * site's header (#1034). The desktop's injected pushState guard no longer reaches the data
 * router (#848), so the page must keep it itself.
 */
export function keepReadonly(params: Record<string, string>, current: URLSearchParams): Record<string, string> {
  if (current.get('readonly') !== 'true') return params;
  const kept: Record<string, string> = { ...params, readonly: 'true' };
  const theme = current.get('theme');
  if (theme) kept.theme = theme;
  return kept;
}
